<template>
	<page>
		<module>
                <module-tab title="基础配置">
                    <c-form ref="baseForm">
                        <c-form title="基础信息">
                            <c-form-item v-model="levelName" type="input" label="代理等级名称" name="level_name" required maxlength="4" placeholder="最多4个字"></c-form-item>
                            <c-form-item label="所属级别" v-if="!id" type="select" name="level_sort" :options="levelOptions" required></c-form-item>
                            <c-form-item v-else type="hidden" name="level_sort"></c-form-item>
                            <c-form-item v-model="levelBgImage" type="image" label="等级页面背景" name="level_bg_img" required button
                                         file-word="建议尺寸：750×1650像素，格式支持：jpg、png">
                            </c-form-item>
                            <c-form-item v-model="cardImage" type="image" label="等级卡片背景" name="level_card_img" required button
                                         file-word="建议尺寸：686×310像素，格式支持：jpg、png<br><a class='s-link' href='https://cdn.yunchange.com/app_static/psd/%E4%BC%9A%E5%91%98%E5%8D%A1%E8%83%8C%E6%99%AF%E6%A8%A1%E6%9D%BF.psd'>下载模板</a>">
                                <c-button slot="button" color="gray" hollow @click="select('card')">选择背景</c-button>
                            </c-form-item>
                            <c-form-item v-model="cardColor" type="color" label="卡片文字颜色" name="card_text_color" required></c-form-item>
                            <c-form-item v-model="levelImage" type="image" label="等级徽章" limit="1" name="level_icon" required button
                                         file-word="建议尺寸：180×180像素，格式支持：jpg、png<br><a class='s-link' href='https://cdn.yunchange.com/app_static/psd/%E4%BC%9A%E5%91%98%E5%BE%BD%E7%AB%A0.psd'>下载模板</a>">
                                <c-button slot="button" color="gray" hollow @click="select('level')">选择徽章</c-button>
                            </c-form-item>
                            <c-form-item v-model="levelColor" type="color" label="徽章文字颜色" name="icon_text_color" required></c-form-item>
                        </c-form>

                        <c-form title="等级折扣" v-if="systemConfig.agency_price_mode == 1">
                            <c-form-item type="number" label="商品折扣" :limit="[1,100]" required name="discount" v-model="priceDiscount" decimal="2" input-unit="%"
                                         word="该等级代理在下单时，平台所有商品可享受的该折扣优惠（设置80%表示商品打8折，若设置为100则不享受折扣）"></c-form-item>
                        </c-form>
                    </c-form>
                </module-tab>

                <module-tab title="升级方式">
                    <c-form ref="upgradeForm">
                        <c-form >
                            <c-form-item v-model="currentWay" label="升级方式" type="checkbox" name="up_type" :options="upgradeWayOptions"
                                         word="不选择任何升级方式，则可以通过后台直接调整的方式获得该代理等级" disabled></c-form-item>
                            <c-form title="自动升级" v-if="autoUpgrade">
                                <c-form-item label="升级门槛" v-model="levelThresholdCount" type="number" name="level_threshold" decimal="0" :limit="[1,999999]" input-unit="件"
                                             required word="购买商品数达到该数量则自动升级"></c-form-item>
                            </c-form>
                            <c-form title="付费升级" v-if="orderLevel" word="请填写升级至当前等级需要支付的金额">
                                <c-form-item label="等级售价" v-model="levelPrice" type="number" name="level_price" decimal="2" input-unit="元" required></c-form-item>
                                <c-form-item v-model="giftsState" type="radio" label="付费升级赠送礼包" name="is_gift_package" :options="giftsOptions" required
                                             word="开启后，通过付费升级成功将赠送礼包"></c-form-item>
                                <c-form-item v-show="giftsState == 2" label="" required>
                                    <c-table v-model="giftsList" border height="auto" style="width: 600px;">
                                        <c-table-column
                                                label="礼包名称"
                                                name="name"
                                                width="240"
                                        ></c-table-column>
                                        <c-table-column
                                                fixed="none"
                                                type="button"
                                                label="操作"
                                                width="80"
                                        >
                                            <template v-slot="row">
                                                <c-table-button @click="giftsList.splice(row.index, 1)">删除</c-table-button>
                                            </template>
                                        </c-table-column>
                                    </c-table>
                                    <div class="flex-center-cross" style="margin-top: 10px;">
                                        <c-button @click="$refs.giftPackageSelector.open()">添加礼包</c-button>
                                        <p class="gifts-tips">可添加多个礼包给客户选择，会员只可选择其中一个礼包</p>
                                    </div>
                                </c-form-item>
                            </c-form>
                            <c-form title="购买指定商品" v-if="presentLevel">
                                <c-form-item v-model="present_upgrade_type" type="radio" label="升级时间" name="present_upgrade_type"
                                             :options="presentUpgradeTypeOptions" required :word="presentUpgradeTypeWord"></c-form-item>
                                <c-form-item label="商品列表" required>
                                    <div class="flex-center-cross" style="margin-top: 10px;">
                                        <c-button color="gray" hollow @click="productSelect()">添加商品</c-button>
                                        <p class="gifts-tips">成功购买以下商品列表中任意一件商品即满足赠送条件，同一件商品只能关联一个等级</p>
                                    </div>
                                    <c-table v-model="presentProductList" ref="presentProduct" border height="auto" style="width: 900px;">
                                        <c-table-column
                                                label="状态"
                                                name="state"
                                                width="60"
                                        >
                                            <template v-slot="{data}">
                                                <span v-if="data.state == 0" style="color:red">{{productStateName[data.state]}}</span>
                                                <span v-if="data.state == 1" style="color:#999999">{{productStateName[data.state]}}</span>
                                                <span v-if="data.state == 2" style="color:green">{{productStateName[data.state]}}</span>
                                                <span v-if="data.state == 3" style="color:blue">{{productStateName[data.state]}}</span>
                                                <span v-if="data.state == 4" style="color:red">{{productStateName[data.state]}}</span>
                                            </template>
                                        </c-table-column>

                                        <c-table-column
                                                label="商品信息"
                                                name="product_name"
                                                width="350"
                                        >
                                            <template v-slot="{data}">
                                                <product-info v-if="data.product_itemnumber" :image="data.product_img_url" :name="data.product_itemnumber + ' - '+data.product_name"></product-info>
                                                <product-info v-else :image="data.product_img_url" :name="data.product_name"></product-info>
                                            </template>
                                        </c-table-column>

                                        <c-table-column
                                                label="售价(元)"
                                                name="product_price"
                                                width="140"
                                        >
                                            <template v-slot="{data}">
                                                ￥{{data.product_price}}
                                            </template>
                                        </c-table-column>
                                        <c-table-column
                                                type="button"
                                                label="操作"
                                                width="50"
                                        >
                                            <template v-slot="row">
                                                <c-table-button @click="presentProductList.splice(row.index, 1)">删除</c-table-button>
                                            </template>
                                        </c-table-column>
                                    </c-table>
                                </c-form-item>
                            </c-form>
                        </c-form>
                    </c-form>
                </module-tab>

                <module-tab title="代理权益">
                    <c-form>
                        <c-form-item type="radio" label="权益展示方式" name="right_type" v-model="rightType"
                                     :options="rightTypeOptions" :value="2" word="" required></c-form-item>

                        <c-form title="系统权益" v-show="rightType == 1">
                            <c-table v-model="systemRights" ref="systemRights" border height="auto" style="width: 900px;">
                                <c-table-column
                                        label="权益类型"
                                        name="system_right_name"
                                        width="120"
                                ></c-table-column>
                                <c-table-column
                                        label="权益名称"
                                        width="150"
                                >
                                    <template v-slot="{data}">
                                        <span style="color: #007FFF;">{{data.right_name}}</span>
                                    </template>
                                </c-table-column>
                                <c-table-column
                                        label="权益图标"
                                        width="100"
                                >
                                    <template v-slot="{data}">
                                        <c-image class="rights-icon" :src="data.right_logo"></c-image>
                                    </template>
                                </c-table-column>
                                <c-table-column
                                        label="描述说明"
                                        width="300"
                                >
                                    <template v-slot="{data}">
                                        <div class="ellipsis-2">{{data.right_content}}</div>
                                    </template>
                                </c-table-column>

                                <c-table-column
                                    type="sort"
                                    label="排序"
                                    width="200"
                                    @sort="sortHandle"
                                ></c-table-column>

                                <c-table-column
                                        label="是否启用"
                                        width="100"
                                >
                                    <template v-slot="{data}">
                                        <c-switch :value="data.state == 1" text="启用,禁用" @change="state => data.state = state ? 1 : 2"></c-switch>
                                    </template>
                                </c-table-column>

                                <c-table-column
                                        type="button"
                                        label="操作"
                                        width="80"
                                >
                                    <template v-slot="row">
                                        <c-table-button @click="editRights(1, row)">编辑</c-table-button>
                                    </template>
                                </c-table-column>
                            </c-table>
                        </c-form>
                        <c-form title="自定义权益" v-show="rightType == 1">
                            <c-table v-model="customRights" ref="customRights" border height="auto" style="width: 900px;">
                                <c-table-column
                                        label="权益名称"
                                        width="150"
                                >
                                    <template v-slot="{data}">
                                        <span style="color: #007FFF;">{{data.right_name}}</span>
                                    </template>
                                </c-table-column>
                                <c-table-column
                                        label="权益图标"
                                        width="100"
                                >
                                    <template v-slot="{data}">
                                        <c-image class="rights-icon" :src="data.right_logo"></c-image>
                                    </template>
                                </c-table-column>

                                <c-table-column
                                    type="sort"
                                    label="排序"
                                    width="200"
                                    @sort="sortHandle"
                                ></c-table-column>

                                <c-table-column
                                    label="是否启用"
                                    width="100"
                                >
                                  <template v-slot="{data}">
                                    <c-switch :value="data.state == 1" text="启用,禁用" @change="state => data.state = state ? 1 : 2"></c-switch>
                                  </template>
                                </c-table-column>

                                <c-table-column
                                        label="描述说明"
                                        width="300"
                                >
                                    <template v-slot="{data}">
                                        <div class="ellipsis-2">{{data.right_content}}</div>
                                    </template>
                                </c-table-column>
                                <c-table-column
                                        type="button"
                                        label="操作"
                                        width="80"
                                >
                                    <template v-slot="row">
                                        <c-table-button @click="editRights(2, row)">编辑</c-table-button>
                                        <c-table-button @click="customRights.splice(row.index, 1)">删除</c-table-button>
                                    </template>
                                </c-table-column>
                            </c-table>
                            <c-button style="margin-top: 10px;" @click="editRights(2)">添加权益</c-button>
                        </c-form>
                        <c-form title="权益图片" v-show="rightType == 2">
                            <c-form-item v-model="rightImage" type="image" label="权益图片" name="right_img" required button
                                         file-word="建议尺寸：宽度750像素，高度自定义，格式支持：jpg、png">
                            </c-form-item>
                        </c-form>
                    </c-form>
                </module-tab>

                <template slot="button">
                    <c-button size="m" power="b_user_level_edit" @click="saveHandle()">提交保存</c-button>
                </template>
		</module>
		
		<c-dialog ref="cardImage" title="选择背景" width="870" height="500" @resolve="selectHandle('card')">
			<div class="card-img flex-wrap">
				<div v-for="(item, i) in cardImageList" :key="i" class="item" :class="{'z-crt': currentCardImage == item}" @click="currentCardImage = item">
					<c-image :src="item" :background="false"></c-image>
				</div>
			</div>
		</c-dialog>
		
		<c-dialog ref="levelImage" title="选择徽章" width="600" height="350" @resolve="selectHandle('level')">
			<div class="level-img flex-wrap">
				<div v-for="(item, i) in levelImageList" :key="i" class="item" :class="{'z-crt': currentLevelImage == item}" @click="currentLevelImage = item">
					<c-image :src="item" :background="false"></c-image>
				</div>
			</div>
		</c-dialog>
		
		<c-dialog ref="rightsIcon" title="选择图标" width="600" height="350" @resolve="selectHandle('rights')">
			<div class="rights-img flex-wrap">
				<div v-for="(item, i) in rightsIconList" :key="i" class="item" :class="{'z-crt': currentRightsIcon == item}" @click="currentRightsIcon = item">
					<c-image :src="item" :background="false"></c-image>
				</div>
			</div>
		</c-dialog>
		
		<c-dialog ref="rightsEdit" title="设置权益" width="600" height="350" @resolve="editRightsHandle">
			<c-form ref="rightsForm">
				<c-form-item type="hidden" name="id"></c-form-item>
				<c-form-item type="input" label="权益名称" required name="right_name" maxlength="6" placeholder="最多6个字"></c-form-item>
				<c-form-item v-model="rightsIcon" type="image" label="权益图标" name="right_logo" required button file-word="建议尺寸：100×100像素的透明图片，格式支持：jpg、png<br><a class='s-link' href='https://cdn.yunchange.com/app_static/psd/%E4%BC%9A%E5%91%98%E6%9D%83%E7%9B%8A%E5%9B%BE%E6%A0%87.psd'>下载模板</a>">
					<c-button slot="button" color="gray" hollow @click="select('rights')">选择图标</c-button>
				</c-form-item>
				<c-form-item type="textarea" label="描述说明" name="right_content"></c-form-item>
			</c-form>
		</c-dialog>
		
		<gift-package-selector ref="giftPackageSelector" multiple @resolve="giftPackageSelectHandle"></gift-package-selector>
        <product-selector ref="productSelector" multiple @resolve="productSelectHandle"></product-selector>
    </page>
</template>

<script>
    import validate from '@/assets/script/validate.js'
    import giftPackageSelector from '@/components/service/gift_package_selector.vue'
    import productSelector from "@/components/service/product_selector.vue";
    import productInfo from "@/components/public/product_info.vue";
    import {mapState} from "vuex";

    export default {
		name: 'level_edit',
		
		components: {
            productSelector,
            productInfo,
            giftPackageSelector
		},
		
		props: {
			id: String
		},

		data() {
			return {
				upgradeWayOptions: [
                    {name: '自动升级',value: 3}
                   /* ,{name: '付费升级',value: 1}
                    ,{name: '购买指定商品',value: 2}*/
                ],
                present_upgrade_type:1,
                presentUpgradeTypeOptions: [
                    {name: '订单支付',value: 1},
                    // ,{name: '订单确认收货',value: 2}
                ],
				currentWay:[3],
				levelOptions: [],
                presentProductList:[],//购买这些商品赠送等级
                levelPrice:null,
                levelThresholdCount:null,       //购买数量达到该标准即可升级
                priceDiscount:1,
                giftsOptions: [
                    {name: '开启',value: 2},
                    {name: '关闭',value: 1}
				],
				giftsState: 1,
				giftsList: [],
				
				cardImage: '',
				cardImageList: [],
				currentCardImage: '',
				cardColor: '',
				
				levelName: '',
				levelImage: '',
				levelBgImage: '',
				levelImageList: [],
				currentLevelImage: '',
				levelColor: '',
				
				systemRights: [],
				customRights: [],
				rightsIcon: '',
				rightsIconList: [],
				currentRightsIcon: '',
                rightType:1,    //等级权益展示方式  1：列表 2：图片
                rightTypeOptions:[
                    {name: '权益列表',value: 1},
                    {name: '权益图片',value: 2}
                ],
                rightImage:''       //权益图片
			}
		},
		
		watch: {
			id() {
				this.update();
			}
		},
		
		computed: {
            ...mapState(['systemConfig']),
            ...mapState({
                productStateName: state => state.dict.productState
            }),
			rightsList() {
				return this.systemRights.filter(item => item.state == 1).concat(this.customRights);
			},
            //自动升级
            autoUpgrade(){
                return this.currentWay.includes(3)||this.currentWay.includes('3');
            },
            //直接购买代理
            orderLevel(){
                return this.currentWay.includes(1)||this.currentWay.includes('1');
            },
            //下单赠送代理等级
            presentLevel(){
                return this.currentWay.includes(2)||this.currentWay.includes('2');
            },

            presentUpgradeTypeWord(){
                return {
                    1: '赠送等级的商品下单支付完成后，代理等级即完成变更，后续发生售后不影响代理等级。',
                    2: '赠送等级的商品确认收货完成后，相应代理的等级才发变更。'
                }[this.present_upgrade_type]
            }
		},
		
		mounted() {
			this.update();
		},

		methods: {
			update() {
				this.request({
					url: '/user_level/sort/list',
					success: data => {
						this.levelOptions = Array.from(data, item => {
							return {
								name: item.name,
								value: item.level_sort
							}
						});
					}
				})
				
				this.request({
					url: '/user_level/params',
					success: data => {
						this.cardImageList = data.level_card_img;
						this.levelImageList = data.level_icon;
						this.rightsIconList = data.right_logo;
					}
				})
				
				if (!this.id) {
					this.request({
						url: '/user_level/right/list',
						success: data => {
							this.systemRights = data;
						}
					})
				} else {
					this.request({
						url: '/user_level/detail',
						data: {
							id: this.id
						},
						success: data => {
							this.priceDiscount = data.level_info.discount||100;
                            this.levelPrice = data.level_info.level_price||null
                            this.levelThresholdCount = data.level_info.level_threshold||null
							this.giftsState = data.gift_package_list.length ? 2 : 1;
                            this.giftsList = data.gift_package_list;
                            this.systemRights = data.sys_right_list;
                            this.customRights = data.custom_right_list;
                            this.presentProductList = data.presentProductList||[];
                            this.$refs.baseForm.set(data.level_info);
                            this.$refs.upgradeForm.set({
                                up_type:data.level_info.up_type
                            });
                            this.rightType = data.level_info.right_type;
                            this.rightImage = data.level_info.right_img;
                        }
					})
				}
			},
			
			select(type) {
				switch (type) {
				case 'card':
					this.currentCardImage = '';
					this.$refs.cardImage.open();
					break;
					
				case 'level':
					this.currentLevelImage = '';
					this.$refs.levelImage.open();
					break;
					
				case 'rights':
					this.currentRightsIcon = '';
					this.$refs.rightsIcon.open();
					break;
				}
			},
			
			selectHandle(type) {
				switch (type) {
				case 'card':
					this.cardImage = this.currentCardImage;
					break;
					
				case 'level':
					this.levelImage = this.currentLevelImage;
					break;
					
				case 'rights':
					this.rightsIcon = this.currentRightsIcon;
					break;
				}
			},
			
			giftPackageSelectHandle(list) {
				list = list.filter(item => {
					return !this.giftsList.find(row => {
						return row.id == item.id;
					});
				});
				this.giftsList = this.giftsList.concat(list);
			},
			
			editRights(type, row) {
				this._editRights = row;
				this.$refs.rightsForm.clear();
				if (row) {
					this.$refs.rightsForm.set(row.data);
				}
				this.$refs.rightsEdit.open();
			},
			
			editRightsHandle(stop, next) {
				stop();
				let data = this.$refs.rightsForm.get();
				validate(data, {
					rule: {
						right_name: '请填写权益名称',
						right_logo: '请上传权益图标'
					},
					success: () => {
						next();
						if (this._editRights) {
							this._editRights.update(data);
						} else {
							this.customRights.push(data);
						}
					}
				});
			},

            /***选择赠品点击事件***/
            productSelect() {
                var params = {
                    present_level:0     //仅查询尚未关联其他等级的商品
                };
                this.$refs.productSelector.open(params);
            },

            /***选择赠品响应事件***/
            productSelectHandle(list) {
                if (list){
                    list = list.filter(item => {
                        return !this.presentProductList.find(row => {
                            return row.product_id == item.product_id;
                        });
                    });
                    this.presentProductList = this.presentProductList.concat(list);
                }
            },

        sortHandle(row, type, next) {
          let submitData ={};
          submitData.type = type;
          if(type=='top' || type=='bottom'){
            submitData.id = row.data.id;
          }
          if(type=='up'){
            submitData.id1 = row.data.id;
            submitData.id2 = row.prev().data.id;
            submitData.type = "";
          }
          if(type=='down'){
            submitData.id1 = row.data.id;
            submitData.id2 = row.next().data.id;
            submitData.type = "";
          }
          next();
        },


			saveHandle() {
				this.$refs.baseForm.submit({
					url: '/user_level/edit',
					rule: {
						level_name: '请填写代理等级名称',
						level_sort: '请选择所属级别',
						level_bg_img: '请上传等级页面背景',
						level_card_img: '请上传等级卡片背景',
						card_text_color: '请选择卡片文字颜色',
						level_icon: '请上传等级徽章',
						icon_text_color: '请选择徽章文字颜色',
                        discount: [{
                            type: 'empty',
                            skip: () => {
                                return this.systemConfig.agency_price_mode != 1;
                            },
                            word: '请填写实物商品折扣'
                        }],
						gifts: [{
							type: 'function',
							fun: () => {
								return this.giftsList.length > 0;
							},
							word: '已开启【付费升级赠送礼包】，请至少选择一个礼包',
							skip: () => {
								return this.giftsState != 2;
							}
						}],
            /*currentWay: [{
                type: 'function',
                fun: () => {
                    return this.currentWay.length > 0;
                },
                word: '请至少选择一种升级方式'
            }],*/
            orderLevel: [{
                type: 'function',
                fun: () => {
                    if (this.orderLevel && (!this.levelPrice || parseFloat(this.levelPrice)<=0)){
                        return false;
                    }else {
                        return true;
                    }
                },
                word: '已开启【付费升级】，请填写等级售价',
            }],
            presentLevel: [{
                type: 'function',
                fun: () => {
                    if (this.presentLevel && this.presentProductList.length==0){
                        return false;
                    }else {
                        return true;
                    }
                },
                word: '已开启【购买指定等级赠送礼包】，请至少添加一件商品',
            }],
            right_img: [{
                type: 'function',
                fun: () => {
                    if (this.rightType == 2 && !this.rightImage){
                        return false;
                    }else {
                        return true;
                    }
                },
                word: '请上传等级权益图片',
            }]
					},
					dataFormatter: data => {
            //如果系统配置的【分销价格体系】是按照商品单独设置售价，则默认折扣1
            if (this.systemConfig.agency_price_mode != 1){
                data.discount = 100;
            }else {
                data.discount = this.priceDiscount;
            }
            var upgradeFormData = this.$refs.upgradeForm.serialize();
            //合并两个Form数据
            data = Object.assign({}, data,upgradeFormData);
            data.id = this.id;
            if (this.giftsState == 2) {
                data.gift_package_list = this.giftsList;
            }
            data.sys_right_list = this.systemRights;
            data.custom_right_list = this.customRights;
            data.up_type = data.up_type?data.up_type.join(','):'';
            if (this.presentProductList){
                data.present_product_list = this.presentProductList.map(item => {
                    return item.product_id;
                })
            }else {
                data.present_product_list = [];
            }
            data.right_type = this.rightType;
            data.right_img = this.rightImage;
            data.level_threshold = this.levelThresholdCount||999999;
						return data;
					},
					success: () => {
						this.$message({
							text: '保存成功'
						});
						this.$bus.$emit('user_level_list.update');
						this.redirectTo('/user_level_list');
					}
				})
			}
		}
	}
</script>

<style lang="stylus" scoped>
	.preview {
		z-index: 1;
		position: sticky;
		top: 70px;
		right: 24px;
		align-self: flex-start;
		width: 375px;
		min-width: 375px;
		min-height: 734px;
		border-radius: 30px;
		background: #242329;
		
		@media screen and (max-width: 1640px) {
			display: none;
		}
		
		&-title {
			height: 62px;
			line-height: 78px;
			font-size: 18px;
			text-align: center;
			color: #fff;
		}
		
		&-user {
			padding: 0 34px;
			
			&-icon {
				width: 50px;
				height: 50px;
				border-radius: 100%;
				margin-right: 12px;
				font-size: 26px;
				background: #F5F5F5;
			}
			
			&-name {
				font-size: 16px;
				color: #fff;
			}
			
			&-level {
				width: 100%;
				height: 22px;
				padding-left: 28px;
				margin-top: 6px;
				line-height: 22px;
				font-size: 12px;
				background-size: auto 100%;
				background-repeat: no-repeat;
			}
		}
		
		&-card {
			position: relative;
			width: 320px;
			height: 140px;
			border-radius: 20px;
			margin: 14px auto 22px;
			overflow: hidden;
			
			p {
				position: absolute;
				left: 26px;
				top: 46px;
				font-size: 24px;
				font-weight: bold;
			}
			
			span {
				position: absolute;
				left: 26px;
				top: 84px;
				font-size: 12px;
				opacity: .7;
			}
		}
		
		&-rights {
			width: 25%;
			height: 100px;
			
			&-title {
				margin-bottom: 10px;
				font-size: 16px;
				text-align: center;
				color: #FBCDA9;
			}
			
			&-icon {
				width: 54px;
				height: 54px;
				border-radius: 100%;
				background: linear-gradient(-40deg, #F5B778, #FFEDD1);
			}
			
			p {
				margin-top: 9px;
				font-size: 13px;
				color: #FAE2BF;
			}
		}
	}
	
	.gifts {
		&-tips {
			margin-left: 20px;
			font-size: 13px;
			color: #999;
		}
	}
	
	.card-img {
		padding: 5px 20px 20px 5px;
		
		.item {
			box-sizing: border-box;
			width: 260px;
			height: 120px;
			border: 1px solid #fff;
			padding: 5px;
			margin-left: 15px;
			margin-top: 15px;
			cursor: pointer;
			
			&:hover,
			&.z-crt {
				border-color: #000;
			}
		}
	}
	
	.level-img {
		padding: 5px 20px 20px 5px;
		
		.item {
			box-sizing: border-box;
			width: 140px;
			height: 50px;
			border: 1px solid #fff;
			padding: 5px;
			margin-left: 15px;
			margin-top: 15px;
			cursor: pointer;
			
			&:hover,
			&.z-crt {
				border-color: #000;
			}
		}
	}
	
	.rights-img {
		padding: 10px 20px 20px 10px;
		
		.item {
			box-sizing: border-box;
			width: 70px;
			height: 70px;
			border: 1px solid #fff;
			padding: 5px;
			margin-left: 10px;
			margin-top: 10px;
			cursor: pointer;
			
			&:hover,
			&.z-crt {
				border-color: #000;
			}
		}
	}
	
	.rights {
		&-icon {
			width: 40px;
			height: 40px;
		}
	}
</style>